	export enum DefaultPageEnum {
		Dashboard = 1,
		Scheduler = 2
	}
